/* @ngInject */
export default class PaymentAuthorisationCtrl {
	constructor(
		$sce,
		$scope,
		$state,
		Utility,
		$timeout,
		$uibModal,
		$rootScope,
		$cacheFactory,
		$templateCache,
		BuildingsService,
		NotificationService,
		LocalStorageService,
		AuthorizationService,
		AuthenticationService,
		paymentAuthorisationDataService
	) {
		this.$sce = $sce;
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$uibModal = $uibModal;
		this.$rootScope = $rootScope;
		this.$cacheFactory = $cacheFactory;
		this.$templateCache = $templateCache;
		this.BuildingsService = BuildingsService;
		this.NotificationService = NotificationService;
		this.LocalStorageService = LocalStorageService;
		this.AuthorizationService = AuthorizationService;
		this.AuthenticationService = AuthenticationService;
		this.paymentAuthorisationDataService = paymentAuthorisationDataService;

		this.init();
		this.activate();
	}

	get selectedContractualPayments() {
		const payments = this.paymentBandData.bandsData.ContractualPayments.filter((payment) => payment.checked);
		return payments;
	}

	get bulkApproveLabel() {
		const hasSelectedPayments = this.selectedContractualPayments && this.selectedContractualPayments.length > 0;
		const label = `BULK APPROVE ${hasSelectedPayments ? `(${this.selectedContractualPayments.length})` : ''}`;
		return label;
	}

	get approvePaymentAuthorisations() {
		const canApprove = this.AuthorizationService.isAuthorized('Approve Payment bands');
		return canApprove;
	}

	get approveContractualPayments() {
		const canApprove = this.AuthorizationService.isAuthorized('Approve Contractual Payments');
		return canApprove;
	}

	init() {
		this.query = '';
		this._switchIsBusy(false);
		this.paymentBandData;
		this.webPortfolio = [];
		this.isQuerying = false;
		this.isApproving = false;
		this.SchemeRef = undefined;
		this.selectedBuildingRef = undefined;
		this.webPortfolioToggle = [];
		this.isBulkApproving = false;
		this.portfolioArrayLength = 0;
		this.webPortfolioComments = [];
		this.disableQuerySubmit = false;
		this.contractualDetails = undefined;

		this.currentAttachment = this.testCache = undefined;

		this.$scope.$on('selected-building-changed', (event, newValue) => {
			this.onSelectedBuildingChanged(event, newValue);
		});

		this.$scope.$watch(
			'paymentAuthorisationVm.BuildingsService.buildingsData.selectedBuilding',
			(newValue, oldValue) => {
				const isSame = this.Utility.buildingRefsAreEqual(newValue, oldValue);
				const lastTriedStr = this.LocalStorageService.retrieve('lastTriedAuthorisation');
				const retryAt = moment(new Date(), this.Utility.dateTimeFormat).add(
					this.Utility.apiRetry.value.toString(),
					this.Utility.apiRetry.units
				);
				const lastTried = moment(lastTriedStr, this.Utility.dateTimeFormat);
				const shouldTryAgain = lastTried ? retryAt.isAfter(lastTried) : false;

				if (isSame) {
					if (lastTried && shouldTryAgain) {
						this.onSelectedBuildingChanged(this, newValue);
						this.LocalStorageService.save(
							'lastTriedAuthorisation',
							moment(new Date()).format(this.Utility.dateTimeFormat)
						);
					} else if (!lastTried) {
						this.onSelectedBuildingChanged(this, newValue);
					}
				} else {
					this.onSelectedBuildingChanged(this, newValue);
				}
			},
			true
		);

		this.$scope.$watch(
			'paymentAuthorisationVm.query',
			(newValue, oldValue) => {
				this.disableQuerySubmit = newValue && newValue.length > 10 ? true : false;
			},
			true
		);
	}

	activate() {
		this._switchIsBusy(true);
		this.paymentBandData = this.paymentAuthorisationDataService;
		this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
		if (this.selectedBuildingRef) {
			this.onSelectedBuildingChanged({}, this.selectedBuildingRef);
		}
		this.testCache = this.$cacheFactory;
	}

	async onSelectedBuildingChanged(event, schemeRef) {
		this.SchemeRef = schemeRef && schemeRef.length > 2 ? schemeRef : this.selectedBuildingRef;
		if (this.SchemeRef && this.SchemeRef.length > 2) {
			this._switchIsBusy(true);
			await this.paymentAuthorisationDataService.getPaymentAuthorisation(this.SchemeRef);
			if (this.paymentBandData.bandsData && this.paymentBandData.bandsData.WebPortfolio) {
				for (let i = 0; i < this.paymentBandData.bandsData.WebPortfolio.length; i++) {
					const portfolio = this.paymentBandData.bandsData.WebPortfolio[i];
					const temp = {
						Id: portfolio.Id,
						Value: false
					};
					this.webPortfolioToggle[i] = temp;
				}
			}

			if (
				this.paymentBandData.bandsData.ContractualPayments &&
				this.paymentBandData.bandsData.ContractualPayments.length > 0
			) {
				this.paymentBandData.bandsData.ContractualPayments.Value = true;
			} else {
				this.paymentBandData.bandsData.ContractualPayments = {
					Value: false
				};
			}
			this._switchIsBusy(false);
		}
	}

	setPanelCollapsed(status, id) {
		console.log(id);
		console.log(status);
		const $collapsing = $('#' + id).hasClass('collapsing');
		if (!$collapsing) {
			status = !status;
		}
		return status;
	}

	shouldShowNote(approverAuthorisation, isNoBand) {
		let shouldShow = false;
		if (isNoBand == true && approverAuthorisation.length == 0) {
			shouldShow = true;
		}

		return shouldShow;
	}

	shouldShowDiscretionary(approverAuthorisation) {
		let shouldShow = false;
		if (typeof approverAuthorisation != 'undefined') {
			for (let i = 0; i < approverAuthorisation.length; i++) {
				const band = approverAuthorisation[i];
				if (band.IsMandatory == false) {
					shouldShow = true;
					break;
				}
			}
		}

		return shouldShow;
	}

	shouldShowMandatory(approverAuthorisation) {
		let shouldShow = false;
		if (typeof approverAuthorisation != 'undefined') {
			for (let i = 0; i < approverAuthorisation.length; i++) {
				const band = approverAuthorisation[i];
				if (band.IsMandatory == true) {
					shouldShow = true;
					break;
				}
			}
		}

		return shouldShow;
	}

	changeGlyphiconPanelHeading(portfolioId) {
		const $collapsing = $(`#${portfolioId || 'contractualPayments'}`).hasClass('collapse in');
		let glyphiconClass = false;

		if (portfolioId === 'contractualPayments') {
			this.paymentBandData.bandsData.ContractualPayments.Value = $collapsing ? false : true;
		} else if (!$collapsing) {
			for (let i = 0; i < this.webPortfolio.length; i++) {
				const portfolio = this.webPortfolio[i];
				if (portfolio.Id == portfolioId) {
					this.webPortfolioToggle[i].Value = !this.webPortfolioToggle[i].Value;
					glyphiconClass = this.webPortfolioToggle[i].Value;
				} else {
					this.webPortfolioToggle[i].Value = false;
				}
			}
		}

		return glyphiconClass;
	}

	innerGlyphStatus(status, id) {
		console.log(status);
		console.log(id);
		const $collapsing = $('#' + id).hasClass('collapsing');
		if (!$collapsing) {
			status = !status;
		}
		return status;
	}

	approvePaymentBand() {
		console.log('Approve clicked');
		this.SchemeRef = this.selectedBuildingRef;
		this.isApproving = true;
		this.paymentAuthorisationDataService
			.approvePaymentAuthorisation(this.SchemeRef)
			.then(
				(results) => {
					if (results.WasSuccessful) {
						console.log('Payment Band Approval succeeded..');
						this.NotificationService.success('APPROVED');
					} else {
						console.log('Payment Band Approval failed');
						this.NotificationService.error('FAILED');
					}
				},
				(err) => {
					console.log('Payment Band Approval failed with the error: ', err);
					this.NotificationService.error('FAILED', err);
				}
			)
			.finally(() => {
				this.isApproving = false;
			});
	}

	queryPaymentBand() {
		this.SchemeRef = this.selectedBuildingRef;
		this.isQuerying = true;
		this.paymentAuthorisationDataService
			.queryPaymentAuthorisation(this.SchemeRef, this.query)
			.then(
				(results) => {
					if (results.WasSuccessful) {
						this.NotificationService.success('QUERIED');
					} else {
						console.log('Payment Band query failed');
					}
					this.query = '';
				},
				(err) => {
					console.log('Payment Band query failed with the error: ', err);
					this.NotificationService.error('FAILED', err);
				}
			)
			.finally(() => {
				this.isQuerying = false;
				$('#paymentAuthorisationModal').modal('hide');
			});
	}

	canApprove() {
		this.selectedBuildingRef = this.selectedBuildingRef ? this.selectedBuildingRef : this.BuildingsService.getSelectedBuildingRef();
		const allowed = this.AuthenticationService.hasRoleForBuilding(this.selectedBuildingRef, 'chairman');
		return allowed;
	}

	checkPayment(paymentId) {
		this.paymentBandData.bandsData.ContractualPayments.forEach((payment) => {
			if (payment.ContractualPaymentId === paymentId) {
				if (!payment.checked) {
					payment.checked = false;
				}
				payment.checked = !payment.checked;
			}
		});
	}

	populateContractualDetailsViewModal(id, evt) {
		this.contractualDetails = this.paymentBandData.bandsData.ContractualPayments.find((payment) => {
			return payment.ContractualPaymentId === id;
		});

		if (this.contractualDetails) {
			this.contractualDetails.ContractualAttachment = this.contractualDetails.ContractualAttachment.map(
				(file) => {
					const attachmentUrl =
						pretorOnlineUrl + `${pretorOnlineUrl.endsWith('/') ? '' : '/'}documents/attachment/${file.Id}`;
					file.documentsUrl = this.$sce.trustAsResourceUrl(`${attachmentUrl}?extension=pdf`);

					return file;
				}
			);

			this.currentAttachment =
				this.contractualDetails.ContractualAttachment &&
					this.contractualDetails.ContractualAttachment.length > 0
					? this.contractualDetails.ContractualAttachment[0]
					: undefined;
		}
	}

	getAttachmentPath(id) {
		const attachment = this.contractualDetails.ContractualAttachment.find((att) => {
			return att.CorrelationId == id;
		});

		this.currentAttachment = attachment;
	}

	queryContractualPayment() {
		const id = this.contractualDetails.ContractualPaymentId;
		const message = this.contractualDetails.queryMessage;

		if (id && message) {
			this.contractualDetails.isQuerying = true;
			this.paymentAuthorisationDataService
				.queryContractualPayment(id, message)
				.then(
					(results) => {
						if (results.WasSuccessful) {
							console.log('Payment Band query succeeded..');
							this.NotificationService.success('QUERIED');
						} else {
							console.log('Payment Band query failed');
							this.NotificationService.error('FAILED');
						}

						this.contractualDetails.queryMessage = undefined;
					},
					(err) => {
						this.NotificationService.error('FAILED');
					}
				)
				.finally(() => {
					this.contractualDetails.isQuerying = false;
					$('#contractualPaymentQueryModal').modal('hide');
				});
		}
	}

	getContractualPaymentIDs() {
		const ids = [];

		this.paymentBandData.bandsData.ContractualPayments.forEach((payment) => {
			if (payment.checked) {
				ids.push(payment.ContractualPaymentId);
			}
		});

		return ids;
	}

	bulkApprove() {
		const paymentIDsForApproval = this.getContractualPaymentIDs();
		this.isBulkApproving = true;
		this.bulkStatusChange(paymentIDsForApproval, true);

		this.paymentAuthorisationDataService
			.approveContractualPayments(paymentIDsForApproval, this.SchemeRef)
			.then(
				() => {
					this.NotificationService.success('SUCCESSFULLY APPROVED');
				},
				(err) => {
					console.error(err);
					this.NotificationService.error('FAILED');
				}
			)
			.finally(() => {
				this.isBulkApproving = false;
				this.bulkStatusChange(paymentIDsForApproval, false);
			});
	}

	bulkStatusChange(IDs, busy) {
		this.paymentBandData.bandsData.ContractualPayments.map((payment) => {
			const id = IDs.find((_id) => {
				return _id === payment.ContractualPaymentId;
			});
			if (id) {
				payment.isApproving = busy;
			}
		});
	}

	approveContractual(id, unApprove) {
		const busyType = unApprove ? 'un-approving' : 'approving';
		this.changeContractualApprovalStatus(id, busyType, true);

		let promise;

		if (unApprove) {
			promise = this.paymentAuthorisationDataService.unApproveContractualPayment(id);
		} else {
			promise = this.paymentAuthorisationDataService.approveContractualPayment(id);
		}

		promise
			.then(
				(results) => {
					const msg = unApprove ? 'APPROVAL CANCELLED' : 'APPROVED';
					this.NotificationService.success(msg);
				},
				(err) => {
					this.NotificationService.error('FAILED');
				}
			)
			.finally(() => {
				this.changeContractualApprovalStatus(id, busyType, false);
			});
	}

	changeContractualApprovalStatus(id, type, busy) {
		this.paymentBandData.bandsData.ContractualPayments.forEach((payment) => {
			if (payment.ContractualPaymentId === id) {
				if (type === 'approving') {
					payment.isApproving = busy;
				} else if (type === 'un-approving') {
					payment.isUnApproving = busy;
				}

				this.contractualDetails = payment;
			}
		});
	}
	_switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}
}
